const getters = {
    sidebar: state => state.app.sidebar,
    size: state => state.app.size,
    device: state => state.app.device,
    token: state => state.admin.accessToken,
    adminID: state => state.admin.adminID,
    arrTab: state => state.tab.arrTab,
    activeTabName: state => state.tab.activeName,
    isNeedComplate: state => state.admin.isNeedComplate,
    isNeedEditPwd: state => state.admin.isNeedEditPwd,
    isSys: state => state.admin.isSys,
    adminRegionLevelName: state => state.admin.adminRegionLevelName,
    adminRegionLevel: state => state.admin.adminRegionLevel,
    adminRegionID: state => state.admin.adminRegionID,
    currentApplicationYear: state => state.admin.currentApplicationYear
}
export default getters